import { render, staticRenderFns } from "./koulutussuunnitelma.vue?vue&type=template&id=bca22744&scoped=true&"
import script from "./koulutussuunnitelma.vue?vue&type=script&lang=ts&"
export * from "./koulutussuunnitelma.vue?vue&type=script&lang=ts&"
import style0 from "./koulutussuunnitelma.vue?vue&type=style&index=0&id=bca22744&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bca22744",
  null
  
)

export default component.exports